import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { SignatureFormComponent } from '../signature-form/signature-form.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DropDownModel } from '../../../domain/model/common/dropDownModel';
import { PropertyEnrollment } from '../../../domain/model/enrollment/propertyEnrollment';
import { OwnerEnrollment } from '../../../domain/model/enrollment/ownerEnrollment';
import { HotelMotelEnrollment } from '../../../domain/model/enrollment/hotelMotelEnrollment';
import { Type } from '@angular/compiler';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from '../dialog-confirm/dialog-confirm.component';
import { CommonServices } from '../../../domain/service/commonService';
import { EnrollmentService } from '../../../domain/service/enrollmentService';

@Component({
  selector: 'app-register-stepper',
  templateUrl: './register-stepper.component.html',
  styleUrl: './register-stepper.component.css'
})
export class RegisterStepperComponent implements AfterViewInit , OnInit {
  states: DropDownModel[] = [];
  country: DropDownModel[] = [];
  @ViewChild(SignatureFormComponent) signatureFormComponent!: SignatureFormComponent;
  @ViewChild('stepper') currentStepper: any;
  addressType:string = '1';
  signatureStepForm = this.fb.group({
    printedName: ['', Validators.required],
    understand : [false, Validators.required],
});
selectUserType = new FormGroup({
  userType: new FormControl('', [
    Validators.required,
   
  ])
});
 
ownerForm = new FormGroup({
    firstName: new FormControl('', [
      Validators.required,
      Validators.maxLength(200),
    ]),
    lastName: new FormControl('', [
      Validators.required,
      Validators.maxLength(200),
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.maxLength(320),
      Validators.email
    ]),
    phoneNumber: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)
    ]),
  });
  managementCompany = new FormGroup({
    businessLegalName: new FormControl('', [
      Validators.required,
     
    ]),
    businessDBAname: new FormControl('', [
     
    ]),
    primaryContactFirstName: new FormControl('', [
      Validators.required,
    ]),
    primaryContactLastName: new FormControl('', [
      Validators.required,
    ]),
    primaryContactEmail: new FormControl('', [
      Validators.required,
      Validators.email
    ]),
    primaryContactPhoneNumber: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)
    ]),
  });
  hotelMotel =  new FormGroup({
    personNameOrCompanyName: new FormControl('', [
      Validators.required,
     
    ]),
    primaryContactEmail: new FormControl('', [
      Validators.required,
     Validators.email
    ]),
    primaryContactPhoneNumber: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)
    ]),
    primaryContactFirstName: new FormControl('', [
      Validators.required,
    ]),
    primaryContactLastName: new FormControl('', [
      Validators.required,
    ]),
  });
  registerAs: string ='0';
  stepCompleted: boolean = false;
  default =  new FormGroup({
 
  });
  addressOwner =  new FormGroup({
    address1:new FormControl('',[Validators.required]),
    address2:new FormControl('',[Validators.required]),
    city:new FormControl('',[Validators.required]),
    state:new FormControl('',[Validators.required]),
    zipCode:new FormControl('', [
      Validators.required,
      Validators.maxLength(400),
      Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)
    ]),
    note:new FormControl(''),
  });

  addressOwnerInternational =  new FormGroup({
    internationalAddressName:new FormControl('',[Validators.required]),
    internationalPoBox:new FormControl('',[Validators.required]),
    internationalCityProvinceState:new FormControl('',[Validators.required]),
    internationalCountry:new FormControl('',[Validators.required]),
    note:new FormControl(''),
  });
  addressProperty =  new FormGroup({
    address1:new FormControl('',[Validators.required]),
    address2:new FormControl('',[Validators.required]),
    city:new FormControl('',[Validators.required]),
    state:new FormControl('',[Validators.required]),
    zipCode:new FormControl('', [
      Validators.required,
      Validators.maxLength(400),
      Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)
    ]),
    websiteUrl:new FormControl(''),
    note:new FormControl(''),
  });
  constructor(public dialogRef: MatDialog, private fb: FormBuilder, private commonServices: CommonServices, private enrollment : EnrollmentService) { }
  ngOnInit(): void {
    this.commonServices.getAllState(233)
    .subscribe(data => {
      this.states = data.sort((a,b) => a.name.localeCompare(b.name));;
    });
    this.commonServices.getAllCountry()
    .subscribe(data => {
      this.country = data;
    });

  }
  ngAfterViewInit(): void {
    this.signatureStepForm = this.signatureFormComponent.signatureStepForm; 
  }

getStepDescription(){
  if (this.registerAs == '1'){
    return "Owner's Info"
  }else{

    return 'Main Info';
  }

  
}

 isCurrentFormValid(stepperIndex :number){
  let isCurrentFormValid   = false;
  switch(stepperIndex) { 
    case 1: { 
  
       break; 
    } 
    case 2: { 
      isCurrentFormValid = this.ownerForm.valid;
       break; 
    } 
    default: { 
       //statements; 
       break; 
    }  
 } 
 return isCurrentFormValid
 }
  goBack(stepper: MatStepper){
    stepper.previous();
}
goForward(stepper: MatStepper){
   
  stepper.next();
  
}

radioChangeAddress(event: any) {
  this.addressType = event.value;
 
  
}
radioChange(event: any) {
 if (event.value == '1'){
  this.ownerForm.clearValidators();
  this.ownerForm = new FormGroup({
    firstName: new FormControl('', [
      Validators.required,
      Validators.maxLength(200),
    ]),
    lastName: new FormControl('', [
      Validators.required,
      Validators.maxLength(200),
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.maxLength(320),
      Validators.email
    ]),
    phoneNumber: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.pattern(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/)
    ]),
  });
 }
  this.registerAs = event.value;
}
onSelectCard(registerAs: string) {
  if (registerAs == '1'){
    this.ownerForm.reset({
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber:  '',
  });
 
   }
  this.registerAs = registerAs;
 
  this.selectUserType.setValue({
    userType: registerAs, 
  });
}
getFormGroup() {
 
  if (this.registerAs == '1'){
  
    return this.ownerForm;
  }
  if(this.registerAs == '2'){
    return this.managementCompany;
  }
  if(this.registerAs == '3'){
    return this.hotelMotel;
  }

 
  return this.signatureStepForm;
} 

getAddressFormGroup() {
 
  if (this.registerAs == '1' && this.addressType == '1'){
  
    return this.addressOwner;
  }
  if (this.registerAs == '1' && this.addressType == '2'){
  
    return this.addressOwnerInternational;
  }
  if (this.registerAs == '2'  && this.addressType == '1'){
  
    return this.addressProperty;
  }
  if (this.registerAs == '2' && this.addressType == '2'){
  
    return this.addressOwnerInternational;
  }
  if (this.registerAs == '3'  && this.addressType == '1'){
  
    return this.addressProperty;
  }
  if (this.registerAs == '3' && this.addressType == '2'){
  
    return this.addressOwnerInternational;
  }
  return   this.addressOwner;
} 
save(){
 
  
  let printedName = this.signatureStepForm.get('printedName')?.value;

  if (this.registerAs == '1'){
//  let modelOwner : OwnerEnrollment = {
 
 
//    printedName: printedName??'',
//    firstName: this.ownerForm.get('firstName')?.value??'',
//    lastName: this.ownerForm.get('lastName')?.value??'',
//    email: this.ownerForm.get('email')?.value??'',
//    phoneNumber: this.ownerForm.get('phoneNumber')?.value??'',
//    streetAddress: this.addressOwner.get('address1')?.value??'',
//    aptUnitSuite:this.addressOwner.get('address2')?.value??'',
//    city: this.addressOwner.get('city')?.value??'',
//    zipCode: this.addressOwner.get('zipCode')?.value??'',
//    internationalAddressName: this.addressOwnerInternational.get('internationalAddressName')?.value??'',
//    internationalPoboxNumber:this.addressOwnerInternational.get('internationalPoBox')?.value??'',
//    internationalCityStateProvince: this.addressOwnerInternational.get('internationalCityProvinceState')?.value??'',
//    note: this.addressType == "1" ? this.addressOwner.get('note')?.value??'' : this.addressOwnerInternational.get('note')?.value??'',
//    stateId:this.addressOwner.get('state')?.value?  Number.parseInt(this.addressOwner.get('state')?.value??'0') ??0 :0,
//    countryId: this.addressOwnerInternational.get('internationalCountry')?.value?  Number.parseInt(this.addressOwnerInternational.get('internationalCountry')?.value??'0') ??0 :0,
//    id: 0
//  };
//  this.enrollment.registerOwner(modelOwner);
  } 
  if (this.registerAs =='2'){
  //  let modelProperty : PropertyEnrollment = {
  //    id: 0,
  //    printedName: printedName??'',
  //    businessLegalName: this.managementCompany.get('businessLegalName')?.value??'',
  //    businessDbaName: this.managementCompany.get('businessDBAname')?.value??'',
  //    primaryContactFirstName: this.managementCompany.get('primaryContactFirstName')?.value??'',
  //    primaryContactLastName: this.managementCompany.get('primaryContactLastName')?.value??'',
  //    primaryContactEmail: this.managementCompany.get('primaryContactEmail')?.value??'',
  //    primartContactPhoneNumber: this.managementCompany.get('primaryContactPhoneNumber')?.value??'',
  //    streetAddress: this.addressProperty.get('address1')?.value??'',
  //    aptUnitSuite:this.addressProperty.get('address2')?.value??'',
  //    city: this.addressProperty.get('city')?.value??'',
  //    stateId:this.addressProperty.get('state')?.value?  Number.parseInt(this.addressProperty.get('state')?.value??'0') ??0 :0,
  //    zipCode: this.addressProperty.get('zipCode')?.value??'',
  //    webSiteUrl: this.addressProperty.get('websiteUrl')?.value??'',
  //    internationalAddressName:this.addressOwnerInternational.get('internationalAddressName')?.value??'',
  //    streetAddressPoBoxNumber: this.addressOwnerInternational.get('internationalPoBox')?.value??'',
  //    internationalCityStateProvince: this.addressOwnerInternational.get('internationalCityProvinceState')?.value??'',
  //    note: this.addressType == "1" ? this.addressProperty.get('note')?.value??'' : this.addressOwnerInternational.get('note')?.value??'',
  //    countryId: this.addressOwnerInternational.get('internationalCountry')?.value?  Number.parseInt(this.addressOwnerInternational.get('internationalCountry')?.value??'0') ??0 :0,
      
  //  };
  // this.enrollment.registerProperty(modelProperty);
  }
  if (this.registerAs =='3'){
  //  let hotelMotelEnrollment : HotelMotelEnrollment = {
  //    id: 0,
  //    printedName: printedName??'',
  //    personName: this.hotelMotel.get('personNameOrCompanyName')?.value??'',
  //    companyName: this.hotelMotel.get('personNameOrCompanyName')?.value??'',
  //    primaryContactFirstName: this.hotelMotel.get('primaryContactFirstName')?.value??'',
  //    primaryContactLastName: this.hotelMotel.get('primaryContactLastName')?.value??'',
  //    email:  this.hotelMotel.get('email')?.value??'',
  //    phone:  this.hotelMotel.get('phoneNumber')?.value??'',
  //    streetAddress: this.addressProperty.get('address1')?.value??'',
  //    aptUnitSuite:this.addressProperty.get('address2')?.value??'',
  //    city: this.addressProperty.get('city')?.value??'',
  //    stateId:this.addressProperty.get('state')?.value?  Number.parseInt(this.addressProperty.get('state')?.value??'0') ??0 :0,
  //    zipCode: this.addressProperty.get('zipCode')?.value??'',
  //    webSiteUrl: this.addressProperty.get('websiteUrl')?.value??'',
  //    internationalAddressName:this.addressOwnerInternational.get('internationalAddressName')?.value??'',
  //    streetAddressPoBoxNumber: this.addressOwnerInternational.get('internationalPoBox')?.value??'',
  //    internationalCityStateProvince: this.addressOwnerInternational.get('internationalCityProvinceState')?.value??'',
  //    note: this.addressType == "1" ? this.addressProperty.get('note')?.value??'' : this.addressOwnerInternational.get('note')?.value??'',
  //    countryId: this.addressOwnerInternational.get('internationalCountry')?.value?  Number.parseInt(this.addressOwnerInternational.get('internationalCountry')?.value??'0') ??0 :0,
     
  //  };
 //  this.enrollment.registerHotelMotel(hotelMotelEnrollment);
  }
  this.stepCompleted = true;
  this.signatureStepForm.reset();
  this.ownerForm.reset();
  this.addressProperty.reset();
  this.addressOwner.reset();
  this.addressOwnerInternational.reset();
  this.managementCompany.reset();
  this.addressProperty.reset();
  this.selectUserType.reset();
   }

   onSelectUserType(number:string){
this.registerAs = number;
   }
   openDialog(): void {
    const dialogRef = this.dialogRef.open(DialogConfirmComponent, {
      width: '479px',
    });
  
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
public onStepChange(event: any): void {
console.log(event);
}
}
